<template>
    <div style="background-color: white; width: 100%;">
        <div style="padding: 20px;">
            <van-image width="100%" height="auto" :src="type === '0' ? require('@/assets/loveInvitation.png') :  require('@/assets/loveInvitation.jpg')"/>
            <div style="display: flex; justify-content: stretch;">
                <van-button color="linear-gradient(to right, #4587DD, #40B6F8)" style="flex:1; margin-right: 20px; border-radius: 6px;" @click="generateInvitationCard">生成我的邀请卡</van-button>
                <van-button color="linear-gradient(to right, #4587DD, #40B6F8)" style="flex:1; border-radius: 6px;" @click="shareInvitationUrl">分享邀请连接</van-button>
            </div>
            <div class="loveShareBox">
<!--                <div style="padding: 15px; display: flex; align-items: center; justify-content: center;">-->
<!--                    <div style="width: 4px; height: 4px; border-radius: 2px; background-color: #1C7CF8;" />-->
<!--                    <div style="font-weight: bold; margin: 0 10px;">爱心分享</div>-->
<!--                    <div style="width: 4px; height: 4px; border-radius: 2px; background-color: #1C7CF8;"/>-->
<!--                </div>-->
<!--                <van-image width="80px" height="80px" :src="require('@/assets/man.png')"/>-->
<!--                <div style="padding: 20px; font-size: 14px;">-->
<!--                    意外伤害残疾保险金；被保险人自意外伤害发生之日起180日内，因该意外伤害导致本合同所附《人身保险伤残判定标准（行业标准）》所列伤残程度之一的，本公司按下列公式计算并给付意外伤害残疾保障金：意外伤害残疾保险金=该保险人的保险金额x伤残程度等级相对应的给付比例-->
<!--                </div>-->
                <van-image width="100%" height="auto" :src="type === '0' ? require('@/assets/loveInvitationText1.jpg') : require('@/assets/loveInvitationText.jpg')"/>
            </div>
        </div>
    </div>
</template>

<script>

    import Vue from 'vue';
    import {Image, Button, Toast} from 'vant';
    import Cookies from 'js-cookie'

    Vue.use(Image).use(Button).use(Toast);

    export default {
        name: "GenerateInvitation",
        data(){
            return {
                type: Cookies.get('type'),
            }
        },
        methods: {
            generateInvitationCard() {
                this.$router.push('/invitationCard')
            },
            shareInvitationUrl() {
                let url = process.env.VUE_APP_SHARE_URL + '?shareId=' + this.$store.state.user.user.userId + '&type=' + Cookies.get('type')
                var textArea = document.createElement('textarea')
                textArea.value = url
                document.body.appendChild(textArea)
                textArea.select()
                try {
                    var msg = document.execCommand('copy') ? '成功' : '失败'
                    console.log('复制内容 ' + msg)
                } catch (err) {
                    console.log('不能使用这种方法复制内容')
                }
                document.body.removeChild(textArea)
                Toast.success('邀请连接已成功复制');
            }
        }
    }
</script>

<style scoped>
    .loveShareBox {
        width: 100%;
        display: flex;
        flex-direction: column;
        box-shadow: 0px 2px 6px 0px rgba(219, 219, 219, 0.5);
        border-radius: 4px;
        margin-top: 20px;
        align-items: center;
    }

</style>
